import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { NotificationName } from 'utils/constants/notification';

import { addNotification } from 'store/models/notification';

export default () => {
    return (dispatch, getState) => {
        const crmActivity = getState().crmActivity;
        const { title, description, dailyLimit, crmId, owners } = crmActivity;
        const body = {
            id: parseInt(crmId, 10),
            title,
            description,
            dailyLimit: dailyLimit ? parseInt(dailyLimit, 10) : null,
            owners: owners.map(({ id }) => ({ id })),
        };
        return fetcher
            .put('/api/v1/crm/activity', body)
            .then(() => {
                dispatch(addNotification(NotificationName.CrmUpdateSuccess));
                dispatch(push(`/new/admin/crm/${crmId}/`));
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.CrmUpdateError));
            });
    };
};
